{
  "common": {
    "search": "Rechercher...",
    "no_results": "Aucun résultat",
    "settings": "Paramètres",
    "description": "Description",
    "unsaved_changes": "Changements non enregistrés"
  },
  "sidebar": {
    "dashboard": "Tableau de bord",
    "analytics": "Analytique",
    "customers": "Clients",
    "orders": "Commandes",
    "products": "Produits",
    "discounts": "Remises",
    "features": "Fonctionnalités",
    "channels": "Canaux",
    "templateStudio": "Template Studio",
    "aiUsage": "Utilisation IA",
    "emailManager": "Gestionnaire Email",
    "demoRequests": "Demandes de démo",
    "logs": "Journaux",
    "auditTrail": "Piste d'audit",
    "support": "Support",
    "settings": "Paramètres"
  },
  "actions": {
    "save": "Sauvegarder",
    "publish": "Publier",
    "unpublish": "Dépublier"
  },
  "charts": {
    "preview_available": "Aperçu disponible",
    "titles": {
      "total_revenue": "Chiffre d'affaires total",
      "total_expenses": "Dépenses totales",
      "net_profit_kpi": "Bénéfice net",
      "orders_kpi": "Commandes",
      "ad_spend_kpi": "Dépenses publicitaires",
      "aov_kpi": "Panier moyen",
      "net_profit_over_time": "Bénéfice net au fil du temps",
      "profit_waterfall": "Breakdown du bénéfice",
      "profit_margin_over_time": "Marge % au fil du temps",
      "income_vs_costs": "Revenus vs Coûts",
      "daily_pl_table": "Tableau P&L quotidien",
      "running_profit": "Bénéfice cumulé",
      "profit_period_comparison": "Bénéfice : Cette période vs Dernière",
      "roas_by_platform": "ROAS par plateforme",
      "roas_over_time": "ROAS au fil du temps",
      "blended_mer": "Efficacité marketing (MER)",
      "ad_spend_percent": "Dépenses pub en % du CA",
      "cpa_over_time": "Coût par commande au fil du temps",
      "campaign_roas_leaderboard": "Classement rentabilité campagnes",
      "ad_set_efficiency_scatter": "Carte d'efficacité des ad sets",
      "creative_performance_table": "Tableau performance créatives",
      "ad_funnel": "Tunnel pub : Vues → Clics → Commandes",
      "cpm_trend": "Tendance CPM",
      "cpc_trend": "Tendance CPC",
      "wasted_ad_spend": "Dépenses pub inutiles",
      "ctr_over_time": "Taux de clic au fil du temps",
      "best_sellers_by_revenue": "Meilleures ventes par CA",
      "revenue_concentration": "Concentration du CA (80/20)",
      "product_sales_trend": "Tendance ventes produits",
      "units_sold_ranking": "Classement unités vendues",
      "revenue_per_unit": "CA par unité par produit",
      "product_return_rate": "Taux de retour par produit",
      "refund_damage_by_product": "Impact des remboursements par produit",
      "product_channel_matrix": "Matrice Produit × Canal",
      "expense_category_donut": "Répartition des dépenses",
      "expense_category_trend": "Tendance catégories coûts",
      "payment_processing_fees": "Frais de paiement",
      "payment_fees_percent": "Frais de paiement en % du CA",
      "shipping_cost_over_time": "Revenus livraison au fil du temps",
      "shipping_per_order": "CA livraison moyen par commande",
      "discount_total_and_rate": "Remises accordées",
      "journal_expense_breakdown": "Répartition dépenses personnalisées",
      "journal_expenses_over_time": "Dépenses personnalisées au fil du temps",
      "true_cost_per_order": "Coût réel par commande",
      "expense_anomaly_detector": "Pics de dépenses inhabituels",
      "daily_inflows_outflows": "Entrées vs Sorties d'argent",
      "cumulative_cash_position": "Solde de trésorerie",
      "ad_spend_vs_revenue_timing": "Timing Dépenses pub vs CA",
      "weekly_cash_summary": "Flux de trésorerie hebdomadaire",
      "break_even_day": "Jour de rentabilité",
      "money_flow_sankey": "Diagramme des flux financiers",
      "return_rate_over_time": "Taux de retour au fil du temps",
      "refund_amount_over_time": "Montant remboursements au fil du temps",
      "refund_type_breakdown": "Répartition types remboursements",
      "refund_true_cost": "Coût réel des remboursements",
      "most_returned_products": "Produits les plus retournés",
      "paid_vs_organic_revenue": "CA Payant vs Organique",
      "paid_vs_organic_trend": "Tendance Payant vs Organique",
      "revenue_by_utm_source": "CA par source de trafic",
      "revenue_by_utm_campaign": "CA par campagne marketing",
      "unattributed_revenue": "CA non attribué",
      "purchase_frequency": "Fréquence d'achat",
      "top_customers_by_revenue": "Top clients par dépenses",
      "customer_concentration": "Concentration du CA par client",
      "new_vs_returning_revenue": "CA Nouveaux vs Anciens clients",
      "avg_revenue_per_customer": "CA moyen par client",
      "revenue_period_comparison": "CA : Cette période vs Dernière",
      "order_volume_over_time": "Volume de commandes au fil du temps",
      "aov_trend": "Tendance panier moyen",
      "revenue_vs_ad_spend_growth": "Croissance CA vs Dépenses pub",
      "spend_vs_roas_scatter": "Dépenses vs Efficacité",
      "sales_by_day_of_week": "Ventes par jour de la semaine",
      "revenue_forecast": "Prévision du CA",
      "expense_forecast": "Prévision des dépenses",
      "profit_forecast": "Prévision du bénéfice",
      "break_even_projection": "Projection de rentabilité",
      "seasonal_index": "Meilleurs et pires jours",
      "what_if_simulator": "Scénario Simulation",
      "activity_timeline": "Chronologie d'activité",
      "revenue_with_action_markers": "CA avec marqueurs d'action",
      "budget_change_impact": "Impact changement budget",
      "budget_increase_efficiency": "Efficacité hausse budget",
      "campaign_toggle_impact": "Impact lancement/pause campagne",
      "pause_resume_comparison": "Comparaison Pause/Reprise",
      "creative_swap_performance": "Performance changement créative",
      "audience_change_impact": "Impact changement audience",
      "ad_approval_tracker": "Suivi approbations pubs",
      "campaign_lifecycle": "Cycle de vie campagne",
      "product_launch_performance": "Performance lancement produit",
      "product_removal_impact": "Impact retrait produit",
      "promo_discount_rule_impact": "Impact promo et règles de remise",
      "refund_spike_analysis": "Analyse pic remboursements",
      "order_fulfillment_funnel": "Tunnel traitement commandes",
      "cancellation_rate_over_time": "Taux d'annulation au fil du temps",
      "activity_volume_vs_revenue": "Volume d'activité vs CA",
      "billing_issues_timeline": "Problèmes de facturation et paiement",
      "action_breakdown_by_type": "Répartition actions par type",
      "before_after_any_action": "Avant/Après n'importe quelle action"
    }
  },
  "templates": {
    "studio": "Template Studio",
    "unsavedChanges": "Changements non enregistrés",
    "saveDraft": "Sauvegarder le modèle",
    "publishTemplate": "Publier le modèle",
    "templateSettings": "Paramètres du modèle",
    "viewOnDesktop": "Bureau",
    "viewOnTablet": "Tablette",
    "viewOnMobile": "Mobile",
    "empty_canvas_title": "Commencez à construire votre modèle",
    "empty_canvas_desc": "Faites glisser des graphiques pour construire votre tableau de bord standard.",
    "drag_from_catalog": "GLISSER DEPUIS LE CATALOGUE",
    "search_charts": "Rechercher des graphiques...",
    "drag_hint": "Glisser sur le canevas",
    "discard_changes": "Abandonner les changements",
    "confirm_discard": "Êtes-vous sûr de vouloir abandonner vos changements ?",
    "ai_assist_title": "Besoin d'aide pour le design ?",
    "ai_assist_body": "Suggestions de mise en page IA bientôt disponibles",
    "simulator": "simulateur"
  },
  "orders": {
    "details": "Détails de la commande",
    "timeline": "Chronologie",
    "customer": "Client",
    "contactInfo": "Informations de contact",
    "invoice": "Facture",
    "viewInvoice": "Voir la facture",
    "downloadPdf": "Télécharger PDF",
    "refund": {
      "button": "Rembourser",
      "modalTitle": "Rembourser la commande",
      "reason": "Raison",
      "amount": "Montant du remboursement (Optionnel)",
      "fullAmountHint": "Laissez vide pour rembourser le montant total.",
      "cancel": "Annuler",
      "confirm": "Confirmer le remboursement",
      "processing": "Traitement...",
      "failed": "Échec du remboursement de la commande",
      "reasons": {
        "requested_by_customer": "Demandé par le client",
        "duplicate": "Doublon",
        "fraudulent": "Frauduleux"
      }
    }
  }
}
